import { FaTruckMoving } from "react-icons/fa";
import React from "react";
import NavBtn from "../NavBtn";

const Suppliers = (props) => {
  const {
    exactPath = "/dashboard/suppliers",
    to = "/dashboard/suppliers",
    partialPath = "/suppliers",
    label = "Suppliers",
  } = props;

  return (
    <NavBtn
      label={label}
      exactPath={exactPath}
      partialPath={partialPath}
      to={to}
      Icon={FaTruckMoving}
    />
  );
};

export default Suppliers;
